import { NotificationAction } from "@config/local-notifications/notification-actions";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { type UserNotification } from "./entity";

export const UserNotificationEntityConfig: HyperEntityConfig<UserNotification> =
  {
    allowApiCrud: false,
    allowApiRead: Roles.User,
    apiPrefilterPerRole: (filter) => {
      if (!remult.user) return;

      filter(Roles.User, {
        toId: remult.user.id,
      });
    },

    async onInsert(entity, e) {
      const navigateAction = entity.actions.find(
        (v) => v.id === NotificationAction.NAVIGATE,
      );
      // await sendPushToUsers(
      //   {
      //     group: PushGroups.DEFAULT,
      //     actions: navigateAction
      //       ? {
      //           category: PushActionCategories.TO_DETAILS,
      //           extra: {
      //             navigate: navigateAction.extra,
      //           },
      //         }
      //       : undefined,
      //     body: entity.content,
      //     title: entity.title,
      //     ongoing: false,
      //     channelId: PushChannels.Main,
      //   },
      //   [entity.toId],
      // );
    },
  };
